const siteConfig = {
  brandName: "Tworvella",
  logo: { wordmark: "Tworvella", symbol: "⅔" },
  tagline: "Ocean at heart, future in mind.",
  description:
    "Slow fashion shaped by the coast, made in considered quantities from lower-impact materials.",
  contact: {
    email: "customs@tworvella.monster",
    address: "Carrer de la Llacuna 162, 08018 Barcelona, Spain",
    hours: "Monday–Friday, 9:00–17:00 CET",
  },
  commerce: {
    locale: "en-US",
    currency: "USD",
    currencySymbol: "$",
    shippingThreshold: 200,
    standardShipping: 9,
    returnWindow: 30,
    discountCode: "OCEAN10",
    discountRate: 0.1,
    orderPrefix: "TT",
    preOrderDispatch: "20 September 2026",
    seasonLabel: "Spring / Summer 2026",
  },
  storage: {
    cart: "Tworvella-cart",
    wishlist: "Tworvella-wishlist",
    discount: "Tworvella-discount",
  },
  social: {
    instagram: "https://www.instagram.com/",
    pinterest: "https://www.pinterest.com/",
    facebook: "https://www.facebook.com/",
  },
};

export const formatPrice = (value) => {
  const numericValue = Number(value) || 0;

  return new Intl.NumberFormat(siteConfig.commerce.locale, {
    style: "currency",
    currency: siteConfig.commerce.currency,
    minimumFractionDigits: Number.isInteger(numericValue) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};

export default siteConfig;
